module.exports = {
  OUTCOME: 'outcome',
  APPROVAL_TAB_OUTCOME: 'outcome:approval',
  QUESTION: 'outcomes:question',
  QGROUP: 'questionGroup'
};
